export default __webpack_public_path__ + "static/media/1897.c44f15da.png";